// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"confetti__fullscreen__omlEy"};